function generateID() {
	const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	const lengthId = 5;
	let id = 'uniq_';
	for (let i = 0; i < lengthId; i++) {
		id += characters.charAt(Math.floor(Math.random() * characters.length));
	}
	return id;
}

function getNextContentTop(currentContentTop) {
	// console.log(currentContentTop);
	let nextContentTop = currentContentTop.nextElementSibling;
	while (nextContentTop && !nextContentTop.classList.contains('js-content_top')) {
	  nextContentTop = nextContentTop.nextElementSibling;
	}
	return nextContentTop;
}

function getNestedTitles() {
	const contentTops = document.querySelectorAll('.js-content_top');
	const wrapper = document.querySelector('.bestSites');
	const titles = [];


	for (let i = 0; i < contentTops.length; i++) {
		const contentTop = contentTops[i];
		const nextContentTop = getNextContentTop(contentTop);
		// console.log({contentTop, nextContentTop});


		const obj = {
			title: contentTop.dataset.title || contentTop.textContent,
			href: contentTop.id || (contentTop.id = generateID()),
			innerArr: []
		}
		// console.log(obj);

		// Find all titles after the current content top and before the next one
		let currentEl = contentTop.nextElementSibling;
		while (currentEl && currentEl !== nextContentTop && currentEl.parentNode === wrapper) {
			if (currentEl.classList.contains('js-content')) {
			const title = currentEl.textContent.trim();
			const href = currentEl.id || (currentEl.id = generateID());
			obj.innerArr.push({title, href});
		  }
		  currentEl = currentEl.nextElementSibling;
		}
		titles.push(obj)
	}
	return titles;
}


function renderObjects(objects) {
	const html = objects.map(obj => {
	  const innerHtml = obj.innerArr.map(innEl => `
		<li class="contents__item">
		  <div class="contents__icon">
			<svg class="svg-icon">
			  <use xlink:href="#bookmark_empty"></use>
			</svg>
		  </div>
		  <a class="contents__text" href="#${innEl.href}">${innEl.title}</a>
		</li>
	  `).join('');

	  return `
	  	<div class="content__topTitle">
			<div class="contents__icon">
				<svg class="svg-icon">
					<use xlink:href="#bookmark_full"></use>
				</svg>
			</div>
			<a class="contents__text" href="#${obj.href}">${obj.title}</a>
		</div>
		<ul class="contents__list">
		  ${innerHtml}
		</ul>
	  `;
	}).join('');
	return html;
}



export default function autoContent(){
	jQuery(function ($) {
		const 	contentList = $('#contentList');
		if(contentList.length){
			const list = getNestedTitles()
			contentList.append(renderObjects(list))

		}
	})
}
